import { useState, useEffect } from "react";
import TextFields from "../../../../components/TextField/text-field.component";
import {
  EditButtonContainer,
  EditButtonContainer1,
  EditLargeInput,
  EditModalButtonContainer,
  EditPhoneBox,
  EditPhoneContainer,
  EditSmallInput,
  EditUserBigText,
  EditUserCloseButton,
  EditUserModalContainer,
  EditUserModalHeader,
  EditUserModalWrapper,
  EditUserSubText,
  Label,
} from "./UserProfile.styles";
import Buttons from "../../../../components/Button/button.component";
import { colors } from "../../../../theme/color";
import { GET_ALL_USERS } from "../../../../graphql/queries/userManagement";
import { useQuery } from "@apollo/client";

interface EditUserCloseButtonProps {
  onClose: () => void;
  onSubmit: () => void;
}

interface UserInfo {
  email: string;
  fullName: string | null;
  id: string;
  phone: string;
  role: string;
  status: string;
  verifiedPhoneNumber: string | null;
  __typename: string;
}

const EditUserModal: React.FC<EditUserCloseButtonProps> = ({ onClose }) => {
  const { loading, error, data: queryData } = useQuery(GET_ALL_USERS);
  const usersInfo: UserInfo[] = queryData?.getAllUsers?.users || [];

  const [selectedUserIndex, setSelectedUserIndex] = useState<number>(0);
  const selectedUserInfo: UserInfo | undefined = usersInfo[selectedUserIndex];

  const [phone, setPhone] = useState(selectedUserInfo?.phone || "");
  const [data, setData] = useState({
    fullname: selectedUserInfo?.fullName || "",
    email: selectedUserInfo?.email || "",
  });

  useEffect(() => {
    if (selectedUserInfo) {
      setData({
        fullname: selectedUserInfo.fullName || "",
        email: selectedUserInfo.email || "",
      });
      setPhone(selectedUserInfo.phone || "");
    }
  }, [selectedUserInfo]);

  const handleFieldChange = (key: string, value: string) => {
    setData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPhone(e.target.value);
  };

  const handleCloseModal = () => {
    onClose();
  };

  return (
    <>
      <EditUserModalWrapper>
        <EditUserModalContainer>
          <EditUserModalHeader>
            <div style={{ paddingLeft: "20px" }}>
              <EditUserBigText>Edit User Details</EditUserBigText>
              <EditUserSubText>Edit and update user details</EditUserSubText>
            </div>
            <EditUserCloseButton onClick={handleCloseModal}>
              X
            </EditUserCloseButton>
          </EditUserModalHeader>
          <div
            style={{ paddingTop: "15px", width: "95%", paddingLeft: "10px" }}
          >
            <div>
              <TextFields
                type="text"
                width="98%"
                label="Full Name"
                value={data.fullname}
                onChange={(value) => handleFieldChange("fullname", value)}
              />
            </div>
            <div>
              <TextFields
                type="text"
                label="Email Address"
                width="98%"
                value={data.email}
                onChange={(value) => handleFieldChange("email", value)}
              />
            </div>
            <br />
            <EditPhoneBox>
              <Label htmlFor="countryCode">Phone Number</Label>
              <EditPhoneContainer>
                <EditSmallInput type="tel" placeholder="+1" />
                <EditLargeInput
                  value={phone}
                  onChange={handlePhoneChange}
                  type="number"
                />
              </EditPhoneContainer>
            </EditPhoneBox>
          </div>
          <EditModalButtonContainer>
            <EditButtonContainer1>
              <Buttons
                label="Cancel"
                cursor="pointer"
                border="10px"
                width="100%"
                height="50px"
                borderLine="1px solid #AFAFAF"
                color={colors.White}
                textColor={colors.NEUTRAL_GREY}
                style={{
                  width: "70%",
                  height: "44px",
                  borderRadius: "10px",
                  border: "1px solid #AFAFAF",
                  color: "#AFAFAF",
                  backgroundColor: "white",
                }}
              />
            </EditButtonContainer1>
            <EditButtonContainer>
              <Buttons
                label="Save"
                cursor="pointer"
                border="10px"
                width="100%"
                height="50px"
                color={colors.ButtonBackgroundColors.primaryDefaultButton}
                // disabled={!isFormValid()}
                style={{
                  width: "100%",
                  height: "44px",
                  borderRadius: "10px",
                  color: "white",
                  backgroundColor: "#00A603",
                }}
              />
            </EditButtonContainer>
          </EditModalButtonContainer>
        </EditUserModalContainer>
      </EditUserModalWrapper>
    </>
  );
};

export default EditUserModal;
